import { dataControllerCentral, dataControllerNorth, dataControllerSouth, } from "./organisations.js";
// This patient is linked to Rio, but has different data
export const zaneBridges = {
    id: "970e623c-9089-46d5-b2f0-184d31a06b0c",
    name: { family: "Bridges", given: "Zane" },
    address: {
        address: "123 Bridge Street, London",
        postalCode: "SE1 A45",
    },
    dateOfBirth: "2001-01-01",
};
// This patient is linked to Rio, and has the same data
export const zaneBridgerton = {
    id: "f27d0f3b-33fe-4cc1-a719-a479db1057c8",
    name: { family: "Bridgerton", given: "Zane" },
    address: {
        address: "10 Another Street, Another Area",
        postalCode: "W1A 1AA",
    },
    dateOfBirth: "1980-01-01",
};
// These number-like patients are really useful for testing merge/unmerge.
// Note that their id starts with the same number as used in their name,
// so it's easy to look at UUIDs in the database and know which patient it is.
export const oneOne = {
    id: "1ac81fc2-468b-42d7-b1fd-0fc055e1bce8",
    name: { family: "One", given: "One" },
    address: {
        address: "123 Bridge Street, London",
        postalCode: "SE1 A45",
    },
    dateOfBirth: "2001-01-01",
};
export const twoTwo = {
    id: "2d9ffee0-0fa3-42c5-9150-b4b9b1b59d19",
    name: { family: "Two", given: "Two" },
    address: {
        address: "123 Bridge Street, London",
        postalCode: "SE1 A45",
    },
    dateOfBirth: "2001-01-01",
};
export const threeThree = {
    id: "3953203b-7905-45fc-a5f4-337a9e8daae2",
    name: { family: "Three", given: "Three" },
    address: {
        address: "123 Bridge Street, London",
        postalCode: "SE1 A45",
    },
    dateOfBirth: "2001-01-01",
};
export const fourFour = {
    id: "42ae41ff-3717-46e7-ace0-5c825d1aea8b",
    name: { family: "Four", given: "Four" },
    address: {
        address: "123 Bridge Street, London",
        postalCode: "SE1 A45",
    },
    dateOfBirth: "2001-01-01",
};
// Patients used to show Data Sharing Partnership functionality
export const zaneNorth = {
    id: "108a4a7c-0772-40c9-bfe9-4e6f1e69ed66",
    name: { family: "North", given: "Zane" },
    address: {
        address: "123 Bridge Street, London",
        postalCode: "SE1 A45",
    },
    dateOfBirth: "2001-01-01",
};
export const zaneCentral = {
    id: "235e0f5f-277a-4411-8a90-4286aa72c1d6",
    name: { family: "Central", given: "Zane" },
    address: {
        address: "123 Bridge Street, London",
        postalCode: "SE1 A45",
    },
    dateOfBirth: "2001-01-01",
};
export const zaneSouth = {
    id: "341b1f4f-cafa-4e80-93c5-d9bc9d33726f",
    name: { family: "South", given: "Zane" },
    address: {
        address: "123 Bridge Street, London",
        postalCode: "SE1 A45",
    },
    dateOfBirth: "2001-01-01",
};
export const defaultLocalPatients = [
    zaneBridges,
    zaneBridgerton,
    oneOne,
    twoTwo,
    threeThree,
    fourFour,
].map((patient) => [
    patient.id,
    {
        type: "demographics",
        demographics: {
            name: patient.name,
            address: patient.address,
            dateOfBirth: patient.dateOfBirth,
        },
    },
]);
export const defaultDspPatients = [
    [dataControllerNorth.id, zaneNorth],
    [dataControllerCentral.id, zaneCentral],
    [dataControllerSouth.id, zaneSouth],
].map(([dataControllerId, patient]) => {
    return {
        patientId: patient.id,
        dataControllerId,
        demographics: {
            type: "demographics",
            demographics: {
                name: patient.name,
                address: patient.address,
                dateOfBirth: patient.dateOfBirth,
            },
        },
    };
});
export const defaultPdsPatients = [
    [
        "ab12623c-9089-46d5-b2f0-184d31a06b0c",
        {
            name: { family: "Bressington", given: "Lalla" },
            address: {
                address: "7 CROSS ROAD, Tadworth, Surrey",
                postalCode: "KT20 5SP",
            },
            dateOfBirth: "2011-07-19",
        },
        {
            name: [
                {
                    id: "1",
                    given: ["LALLA"],
                    family: "BRESSINGTON",
                    prefix: [""],
                    use: "usual",
                    period: { start: "2000-01-01" },
                },
            ],
            address: [
                {
                    use: "home",
                    id: "1",
                    postalCode: "KT20 5SP",
                    line: ["7 CROSS ROAD", "Tadworth", "Surrey"],
                },
            ],
            id: "9449306257",
            meta: {
                versionId: "1",
                security: [
                    {
                        system: "http://terminology.hl7.org/CodeSystem/v3-Confidentiality",
                        code: "U",
                        display: "unrestricted",
                    },
                ],
            },
            extension: [],
        },
    ],
];
//# sourceMappingURL=patients.js.map